<template>
  <v-app id="app">
    <component :is="layout">
      <router-view />
    </component>
    <div
      class="sr-only"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      {{ a11yAnnouncement }}
    </div>
    <v-overlay absolute :value="loading" z-index="100">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'
import Api from './model/api'
import { Trans } from "@/plugins/Translation"
import { a11yAnnouncements } from '@/utils/message.plagin'

const DEFAULT_LAYOUT = 'main'

export default {
  metaInfo: () => ({
    title: 'ЕДИНЫЙ ПОРТАЛ ОБЩЕСТВЕННЫХ ОБСУЖДЕНИЙ',
    // override the parent template and just use the above title only
    titleTemplate: '%s | ЕДИНЫЙ ПОРТАЛ ОБЩЕСТВЕННЫХ ОБСУЖДЕНИЙ'
  }),
  computed: {
    layout() {
      return (this.$route.meta.layout || DEFAULT_LAYOUT) + '-layout'
    },
    loading() {
      return this.$store.state.app.loading
    },
    a11yAnnouncement() {
      return a11yAnnouncements.message
    }
  },
  mounted () {
    this.$store.dispatch('searchData')
    this.$store.dispatch('notifications')
  },
  created() {
    this.checkUser()
    this.setTransactions()
  },
  methods: {
    ...mapActions(['checkUser']),
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push(Trans.i18nRoute({ name: 'login' }))
      })
    },
    async setTransactions () {
      await Api.getTranslations().then((response) => {
        this.$i18n.setLocaleMessage('ru', response.data.ru)
        this.$i18n.setLocaleMessage('kg', response.data.kg)
      })
    }
  }
}
</script>

<style>
@import 'assets/index.css';
@import 'assets/mobile.css';
</style>
